import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetomumbaibusonhire() {



const cardData =
  {
    keyword: 'Pune to Mumbai Bus on Hire',
    heading: 'Sanavi Travels: Pune to Mumbai Bus on Hire',
    headingDescription: 'Sanavi Travels offers reliable, comfortable, and professional Pune to Mumbai Bus on Hire services for all types of group travel requirements. The Pune–Mumbai route is one of the busiest and most important intercity corridors in Maharashtra, widely used for corporate travel, weddings, educational trips, pilgrimages, leisure outings, and family tours. Hiring a bus from Pune to Mumbai ensures smooth group coordination, cost-effective travel, and a relaxed journey without the stress of driving multiple vehicles. Sanavi Travels provides a wide fleet of AC and Non-AC buses, including luxury coaches, mini buses, and 32 seater or 35 seater buses, all maintained to high safety and cleanliness standards. Our buses are equipped with comfortable seating, ample legroom, strong suspension for highway travel, and sufficient luggage space, making them ideal for long-distance journeys on expressways. With experienced highway drivers, disciplined driving practices, punctual departures, and transparent pricing, Sanavi Travels ensures a safe, timely, and enjoyable Pune to Mumbai bus journey for corporate teams, wedding guests, tourists, and families alike.',

    top: 'Popular Travel Uses and Routes for Pune to Mumbai Bus Hire',


"topPlaces": [
  {
    "title": "Corporate Travel Pune to Mumbai",
    "description": "Corporate teams frequently travel from Pune to Mumbai for meetings, conferences, training programs, exhibitions, and client visits. A hired bus allows employees to travel together comfortably, maintain schedules, and avoid delays caused by coordinating multiple cars or taxis. It also ensures a professional travel experience with fixed reporting times and smooth highway travel."
  },
  {
    "title": "Wedding Guest Transportation",
    "description": "Weddings often require transporting guests from Pune to Mumbai for ceremonies, receptions, or return journeys. Bus hire ensures all guests reach the venue together, reduces travel stress for families, and avoids parking and traffic issues in busy Mumbai areas."
  },
  {
    "title": "Picnic and Leisure Trips",
    "description": "Families, schools, and office groups often plan picnic trips from Pune to Mumbai beaches, amusement parks, or sightseeing spots. A hired bus offers safe, economical, and enjoyable travel while keeping the entire group together."
  },
  {
    "title": "Outstation Tourist Travel",
    "description": "Tourists traveling from Pune to Mumbai prefer buses for city sightseeing, hotel transfers, and onward connections. Bus hire ensures smooth transit on expressways and hassle-free group movement."
  },
  {
    "title": "School and College Excursions",
    "description": "Educational institutions regularly arrange visits to Mumbai for academic tours, competitions, museums, and industrial visits. A hired bus ensures student safety, disciplined travel, and proper supervision."
  },
  {
    "title": "Airport and Railway Transfers",
    "description": "Groups traveling to Mumbai airport or major railway stations from Pune often hire buses to manage luggage and ensure timely arrival for flights or trains."
  },
  {
    "title": "Religious and Spiritual Tours",
    "description": "Devotees traveling between Pune and Mumbai for religious programs, events, or pilgrimages prefer bus hire for organized and comfortable group travel."
  },
  {
    "title": "Corporate Events and Exhibitions",
    "description": "Mumbai hosts large-scale exhibitions, trade fairs, and corporate events. Bus hire allows Pune-based teams to attend events together and return safely."
  },
  {
    "title": "Family Group Travel",
    "description": "Large families traveling from Pune to Mumbai for celebrations, functions, or holidays prefer bus rentals to travel together comfortably and economically."
  },
  {
    "title": "Expressway Highway Travel",
    "description": "The Pune–Mumbai Expressway is ideal for bus travel, offering smooth roads and fast connectivity, making bus hire a preferred option for long-distance group travel."
  }
]
,



"services": [
{
"name": "Pune to Mumbai Bus on Hire",
"description": "Pune to Mumbai Bus on Hire provides a reliable and organized transportation solution for groups traveling between these two major cities. These buses are designed for highway comfort with spacious seating, proper legroom, smooth suspension, and excellent safety features. Sanavi Travels ensures disciplined driving, punctual pickups, and hassle-free coordination, making it ideal for weddings, corporate travel, educational tours, and family trips. Hiring a bus eliminates the stress of multiple vehicles, reduces overall travel cost, and ensures the entire group travels together comfortably."
},
{
"name": "Pune to Mumbai Bus Rental",
"description": "Pune to Mumbai Bus Rental offers flexible options for AC, Non-AC, luxury, and mini buses depending on group size and budget. These buses are suitable for day trips, overnight journeys, return travel, and multi-day bookings. With transparent pricing and professional service, bus rental from Pune to Mumbai ensures peace of mind and efficient travel planning."
},
{
"name": "AC Bus Hire Pune to Mumbai",
"description": "AC Bus Hire Pune to Mumbai is ideal for long-distance travel, especially during summer or peak travel seasons. Air-conditioned buses provide a cool and comfortable environment, making journeys relaxing for passengers of all ages. These buses are widely used for corporate events, wedding guests, and premium group travel."
},
{
"name": "Non AC Bus Rental Pune to Mumbai",
"description": "Non AC Bus Rental Pune to Mumbai is a budget-friendly option suitable for short-duration travel, student groups, and economical tours while still ensuring safety and comfort."
},
{
"name": "Luxury Bus on Rent Pune to Mumbai",
"description": "Luxury Bus on Rent Pune to Mumbai offers premium interiors, superior seating, and enhanced comfort for VIP travel, weddings, and executive corporate groups. These buses deliver a refined travel experience on highways."
},
{
"name": "Mini Bus Hire Pune to Mumbai",
"description": "Mini Bus Hire Pune to Mumbai is suitable for smaller groups that require comfort without hiring a full-size coach, offering flexibility and affordability."
},
{
"name": "32 Seater Bus Pune to Mumbai",
"description": "32 Seater Bus Pune to Mumbai is one of the most preferred options for medium-sized groups, offering the perfect balance of capacity, comfort, and cost efficiency."
},
{
"name": "35 Seater Bus Pune to Mumbai",
"description": "35 Seater Bus Pune to Mumbai is ideal for larger groups, ensuring sufficient seating and luggage space for long-distance highway travel."
},
{
"name": "Bus Hire Pune to Mumbai for Wedding",
"description": "Bus Hire Pune to Mumbai for Wedding ensures smooth guest transportation, timely arrivals, and stress-free travel between venues, hotels, and cities."
},
{
"name": "Bus Hire Pune to Mumbai for Corporate",
"description": "Bus Hire Pune to Mumbai for Corporate travel supports conferences, meetings, exhibitions, and official visits with punctual and professional transportation."
},
{
"name": "Bus Hire Pune to Mumbai for Picnic",
"description": "Bus Hire Pune to Mumbai for Picnic offers safe and enjoyable group travel for schools, offices, and families planning leisure outings."
},
{
"name": "Affordable Pune to Mumbai Bus Rental",
"description": "Affordable Pune to Mumbai Bus Rental provides cost-effective group travel without compromising on safety, comfort, or service quality."
},
{
"name": "Best Pune to Mumbai Bus Service",
"description": "Best Pune to Mumbai Bus Service by Sanavi Travels is trusted for clean buses, experienced drivers, and dependable highway travel."
},
{
"name": "Bus Rental Pune to Mumbai with Driver",
"description": "Bus Rental Pune to Mumbai with Driver ensures professional chauffeur-driven service where drivers handle navigation, traffic, and timing efficiently."
},
{
"name": "Outstation Bus Hire Pune to Mumbai",
"description": "Outstation Bus Hire Pune to Mumbai is ideal for long-distance group travel, offering reliability, comfort, and organized transportation for all travel needs."
}
],
"tableData": [
["Pune to Mumbai Bus Hire", "Pune to Mumbai Bus Rental"],
["AC Bus Pune to Mumbai", "Non AC Bus Pune to Mumbai"],
["Luxury Bus Pune to Mumbai", "Mini Bus Pune to Mumbai"],
["32 Seater Bus Pune to Mumbai", "35 Seater Bus Pune to Mumbai"],
["Wedding Bus Pune to Mumbai", "Corporate Bus Pune to Mumbai"],
["Picnic Bus Pune to Mumbai", "Outstation Bus Pune to Mumbai"],
["Affordable Bus Pune to Mumbai", "Best Bus Service Pune to Mumbai"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Pune to Mumbai Bus Hire with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers dependable and comfortable bus services between Pune and Mumbai."
  },
  {
    "WhyChooseheading": "Highway Travel Expertise",
    "WhyChoosedescription": "Experienced drivers trained for expressway and highway routes."
  },
  {
    "WhyChooseheading": "Comfortable Fleet",
    "WhyChoosedescription": "Clean, spacious, and well-maintained buses for long journeys."
  },
  {
    "WhyChooseheading": "Flexible Bus Options",
    "WhyChoosedescription": "AC, Non-AC, luxury, mini, 32 seater, and 35 seater buses available."
  },
  {
    "WhyChooseheading": "Transparent Pricing",
    "WhyChoosedescription": "Clear and upfront pricing with no hidden charges."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Travel",
    "WhyChoosedescription": "All buses are cleaned and sanitized before each trip."
  },
  {
    "WhyChooseheading": "On-Time Service",
    "WhyChoosedescription": "Punctual pickups and reliable scheduling."
  },
  {
    "WhyChooseheading": "24/7 Support",
    "WhyChoosedescription": "Customer assistance available throughout the journey."
  }
]

}

const faqData = [
  {
    question: 'Do you provide Pune to Mumbai bus hire services?',
    answer: 'Yes, Sanavi Travels provides reliable bus hire services from Pune to Mumbai.'
  },
  {
    question: 'Are AC buses available for Pune to Mumbai travel?',
    answer: 'Yes, AC buses are available for comfortable long-distance travel.'
  },
  {
    question: 'Can buses be hired for weddings and corporate trips?',
    answer: 'Yes, buses can be hired for weddings, corporate events, picnics, and tours.'
  },
  {
    question: 'Is a driver included with the bus?',
    answer: 'Yes, all bus rentals include experienced professional drivers.'
  },
  {
    question: 'Are the buses suitable for expressway travel?',
    answer: 'Yes, all buses are maintained and suitable for expressway and highway travel.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rahul Deshmukh',
    feedback: 'We hired a bus from Pune to Mumbai for a corporate event. Smooth ride and excellent service.',
    rating: 5
  },
  {
    id: 2,
    name: 'Mrs. Neha Kulkarni',
    feedback: 'Sanavi Travels arranged a comfortable bus for our wedding guests traveling from Pune to Mumbai.',
    rating: 5
  }
];


























  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];








const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mumbai Bus on Hire - Sanavi Travels",
  "description": "Sanavi Travels offers Pune to Mumbai bus on hire for weddings, corporate travel, picnics, and outstation trips. We provide AC and Non-AC buses, luxury buses, mini buses, 32 seater and 35 seater buses with professional drivers at affordable rates.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "10000+"
  }
};







  return (
    <div>

<Helmet>
  <title>
    Pune to Mumbai Bus on Hire | Bus Rental Service | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book Pune to Mumbai bus on hire for group travel, corporate trips, weddings and tours. AC/Non-AC buses, tempo travellers and luxury coaches at best prices with driver."
  />

  <meta
    name="keywords"
    content="Pune to Mumbai Bus on Hire, Bus Rental Pune to Mumbai, Pune Mumbai Bus Service, AC Bus Hire Pune, Luxury Bus Pune to Mumbai, Group Travel Bus Pune, Tempo Traveller Pune Mumbai"
  />

  <link
    rel="canonical"
    href="https://www.sanavitravels.com/pune-to-mumbai-bus-on-hire"
  />

  {/* Open Graph */}
  <meta property="og:type" content="website" />
  <meta
    property="og:title"
    content="Pune to Mumbai Bus on Hire | Sanavi Travels"
  />
  <meta
    property="og:description"
    content="Affordable bus rental from Pune to Mumbai for group travel, corporate trips, weddings and outstation tours."
  />
  <meta
    property="og:url"
    content="https://www.sanavitravels.com/pune-to-mumbai-bus-on-hire"
  />

  {/* Schema */}
  <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Service",
      "name": "Pune to Mumbai Bus on Hire",
      "serviceType": "Outstation Bus Rental Service",
      "provider": {
        "@type": "LocalBusiness",
        "name": "Sanavi Travels",
        "telephone": "+91 7387507373"
      },
      "areaServed": {
        "@type": "Place",
        "name": "Pune to Mumbai Route"
      },
      "description":
        "Bus rental service from Pune to Mumbai for group travel, corporate trips, weddings and tours with AC, Non-AC and luxury coaches.",
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": 4.7,
        "bestRating": 5,
        "worstRating": 1,
        "ratingCount": 10000
      }
    })}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/246.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetomumbaibusonhire;